// @ts-nocheck

import React, { useContext } from "react";

import { TextareaProps } from "./Textarea.props";
import LabelTextItem from "../../LabelTextItem";
import TextareaComponent from "./Textarea";

import { FormContext, useFormField } from "../../Form";

/**
 * @deprecated Use `import { TextArea } from capitalrx-components-2.0/lib/forms` instead.
 */
const Textarea: React.FC<TextareaProps> = (props: TextareaProps): JSX.Element => {
  const { id, labelText, name, displayReadOnlyFieldInline, containerClassName, readOnly, isLoading, defaultValue } = props;
  const formContextValues = useContext(FormContext);

  const fieldValue = useFormField(name || "");
  let component = null;

  if (formContextValues.readOnly || readOnly) {
    const textAreaValue = fieldValue && new Array(String(fieldValue)).filter(Boolean).join("\r\n");
    component = (
      <LabelTextItem
        id={id}
        label={labelText}
        displayInline={displayReadOnlyFieldInline}
        body={textAreaValue || defaultValue}
        isLoading={formContextValues.formState.isFormLoading || isLoading}
        className={containerClassName}
      />
    );
  } else {
    component = <TextareaComponent {...props} {...formContextValues} />;
  }

  return component;
};

/**
 * @deprecated
 */
export default Textarea;
